/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Rule_Sets_DescriptionInputs */

const en_tables_rule_sets_description = /** @type {(inputs: Tables_Rule_Sets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets Description`)
};

const de_tables_rule_sets_description = /** @type {(inputs: Tables_Rule_Sets_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung`)
};

/**
* | output |
* | --- |
* | "Sets Description" |
*
* @param {Tables_Rule_Sets_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_rule_sets_description = /** @type {((inputs?: Tables_Rule_Sets_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Rule_Sets_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_rule_sets_description(inputs)
	return de_tables_rule_sets_description(inputs)
});